import { useEffect, useState } from 'react';

const SCRIPT_ID = 'layouts-v2-tailwind-cdn';

/**
 * Inject Tailwind CDN once for layouts-v2 pages (CRA has no Tailwind build).
 * Scope utilities to .layouts-v2-root and disable preflight so MUI isn't nuked.
 */
export function useTailwindCdn() {
  const [ready, setReady] = useState(
    () =>
      typeof document !== 'undefined' &&
      !!document.getElementById(SCRIPT_ID) &&
      typeof window !== 'undefined' &&
      !!window.tailwind,
  );

  useEffect(() => {
    const applyConfig = () => {
      if (typeof window === 'undefined' || !window.tailwind) return;
      try {
        window.tailwind.config = {
          important: '.layouts-v2-root',
          corePlugins: { preflight: false },
        };
      } catch (_) {
        // ignore config races
      }
    };

    const existing = document.getElementById(SCRIPT_ID);
    if (existing) {
      applyConfig();
      setReady(true);
      return;
    }

    // Remove stale inline config scripts that referenced `tailwind` before CDN load
    const stale = document.getElementById('layouts-v2-tailwind-config');
    if (stale) stale.remove();

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.src = 'https://cdn.tailwindcss.com';
    script.async = true;
    script.onload = () => {
      applyConfig();
      setReady(true);
    };
    script.onerror = () => setReady(true);
    document.head.appendChild(script);
  }, []);

  return ready;
}
